(function () {
    'use strict';

    angular.module('app')
        .factory('Color', Color);

    /* @ngInject */
    function Color($resource) {
        return $resource('api/admin/color/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/color/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/color/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/color/findAll'
            }
        });
    }
})();
